// Dark theme JS
// Minimal logic needed, mostly handled by Alpine from main bundles.
console.log('Dark Theme Loaded');
